@if (selectedClassData) {
<div class="col th-p notification-content-wrapper mt-2">
  <header class="top-box-shadow interVideoStyle">
    <div class="columns is-gapless is-vcentered is-mobile">
      <figure class="has-text-centered">
        <i
          class="hideMobileView fa"
          [ngClass]="{
            'fa-angle-double-left': !this.videoQuizComponent.viewClassRoomList,
            'fa-angle-double-right': this.videoQuizComponent.viewClassRoomList
          }"
          (click)="hideShowClassRoom()"
        ></i>
      </figure>
      <div class="column is-10">
        <h3 class="is-marginless is-clearfix">
          <span
            class="is-size-6 has-text-weight-semibold ellipsis list-active"
            title="{{ selectedClassData.chat_group_name }}"
            >{{ selectedClassData.chat_group_name }}</span
          >
          <small class="display-b is-size-7 text-clr-grey">
            {{ selectedClassData.createdAt | date : "MMM d, y h:mm a" }}
          </small>
        </h3>
      </div>
      <div class="column is-2">
        <a class="mobileViewBtn">
          <button
            class="button is-link is-outlined is-small"
            (click)="closeActiveUrl()"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </a>
      </div>
    </div>
  </header>
  <div class=""></div>
  <div class="contents pos-relative">
    <div
      class="notifications scroll-bar"
      infinite-scroll
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="fetchNextLessonDetails()"
    >
      @if (!viewControl.showHideLessonTileView) {
      <div class="videoQuizTileView">
        <div class="flex-container">
          @for (item of getLessonRecords; track item; let i = $index) {
          <div class="flex-item">
            <div class="card">
              <div class="card-image">
                @if (item.message_type === 'file') {
                <figure class="image is-4by4">
                  <div class="lesson_image">
                    <img
                      style="max-height: 150px"
                      class="thumb_img"
                      [src]="item.thumb_Url"
                      (click)="editLessonDetails(item.message_id)"
                    />
                    <span class="thumbImg_span">&nbsp;</span>
                    @if (item.is_assessment_found===true ||
                    item.is_survey_found===true || item.is_poll_found===true) {
                    <a
                      class="thumb_play is-small"
                      (click)="editLessonDetails(item.message_id)"
                    >
                      <i class="fa fa-play-circle-o" aria-hidden="true"></i>
                    </a>
                    }
                  </div>
                  <span class="videoDuration">
                    <div>{{ item.duration }}</div>
                  </span>
                </figure>
                }
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <div class="columns">
                      <div class="column">
                        <p
                          class="title is-7 is-capitalized"
                          [title]="item.message"
                        >
                          {{ item.message != "" ? item.message : "No Title" }}
                        </p>
                        <div
                          class="fileBtnOptions has-text-right is-pulled-right is-4"
                        >
                          <div class="dropdown is-right">
                            <div class="dropdown-trigger">
                              @if (item.is_assessment_found===true ||
                              item.is_survey_found===true ||
                              item.is_poll_found===true) {
                              <div>
                                <a
                                  class="is-small pad-5-10 has-tooltip-left"
                                  data-tooltip="Edit Policy"
                                  (click)="editLessonDetails(item.message_id)"
                                >
                                  <i
                                    class="fa fa-ellipsis-v"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                              } @else {
                              <span
                                class="has-tooltip-top"
                                data-tooltip="There is no question to link to this video."
                              >
                                <i
                                  class="fa fa-info-circle"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              }
                            </div>
                          </div>
                        </div>
                        <p class="shared">{{ item.shared_by }}</p>
                        <p class="subtitle is-6">
                          {{ item.created_at | date : "MMM d, y" }}
                        </p>
                        <!-- <p class="subtitle is-6">
                                  {{
                                  item.read_user_ids ? item.read_user_ids?.length : 0
                                  }}
                                  Views
                                </p> -->
                        @if (item.price > 0) {
                        <p class="title has-text-right is-size-3 btn_buylesson">
                          $ {{ item.price }}
                          <!-- <button *ngIf="item.price > 0" class="button is-link is-outlined is-small">Buy</button> -->
                        </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }
      <!--Edit Lesson video Quiz-->
      @if (viewControl.showHideLessonTileView) {
      <div class="videoQuizTileView">
        <div class="flex-container">
          <div class="flex-item" style="width: 100%">
            <div class="card">
              <div class="card-header">
                <div style="width: 100%">
                  <p class="card-header-title">Add Interaction content</p>
                  <p
                    class="subtitle is-6"
                    style="font-size: 13px; color: #c7c6c6 !important"
                  >
                    {{ getLastUpdateDate | date : "MMM d, y h:mm a" }}
                  </p>
                </div>
                <a
                  class="card-header-icon"
                  aria-label="Close interaction content"
                  (click)="closeModalVideoQuiz()"
                >
                  <span class="icon">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
              <div class="card-body">
                <div class="columns is-clearfix">
                  <div class="column is-5">
                    <div class="cs-media-player">
                      <vg-player>
                        <vg-overlay-play></vg-overlay-play>
                        <vg-buffering></vg-buffering>
                        <vg-scrub-bar>
                          <vg-scrub-bar-current-time></vg-scrub-bar-current-time
                          >/
                          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                          <!-- <vg-scrub-bar-cue-points class="myCuepoints"
                                vg-cue-points="markerSeekBar"></vg-scrub-bar-cue-points> -->
                          <div id="seek-bar-container">
                            <div id="seek-bar">
                              <div id="current-time" class="current-time">
                                @for (percent of markerSeekBar; track percent) {
                                <div
                                  class="bubles"
                                  [ngStyle]="{ left: percent }"
                                ></div>
                                }
                              </div>
                            </div>
                          </div>
                        </vg-scrub-bar>
                        <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                          <!-- <vg-playback-button vgFor="my-video" [playbackValues]="[ '1.0', '2.0', '4.0' ]"></vg-playback-button> -->
                          <vg-play-pause></vg-play-pause>
                          <vg-time-display
                            vgProperty="current"
                            vgFormat="mm:ss"
                          ></vg-time-display>
                          <vg-time-display
                            vgProperty="total"
                            vgFormat="mm:ss"
                          ></vg-time-display>
                          <vg-scrub-bar
                            style="pointer-events: none"
                          ></vg-scrub-bar>
                          <vg-mute></vg-mute>
                          <vg-volume></vg-volume>
                          <vg-fullscreen></vg-fullscreen>
                        </vg-controls>
                        <video
                          #media
                          [vgMedia]="media"
                          id="singleVideo"
                          crossorigin
                          (timeupdate)="getVideoPlayingOnTime($event)"
                        >
                          <source [src]="videoUrl" type="video/mp4" />
                        </video>
                      </vg-player>
                    </div>
                    <div class="columns" style="margin-top: 5px">
                      <div class="column is-9">
                        <p
                          class="is-size-6 title is-7 is-capitalized"
                          style="overflow: inherit"
                          title="{{ lessonTitle }}"
                          [innerHTML]="lessonTitle"
                        ></p>
                        <p class="shared">
                          <!-- {{ item.shared_by }} - -->
                          {{ lessonCreateAt | date : "MMM d, y" }}
                        </p>
                      </div>
                    </div>
                    <!-- <div canplay id="video-block">
                          <div id="video-container">
                            <video
                              class="video-stream"
                              controls
                              #videoStream
                              (timeupdate)="getVideoPlayingOnTime($event)"
                              >
                              <source [src]="videoUrl" type="video/mp4" />
                            </video>
                          </div>
                          <div
                            id="video-controls"
                            style="position: relative; display: block"
                            >
                            <div id="seek-bar-container">
                              <div id="seek-bar">
                                <div id="current-time" class="current-time">
                                  <div class="bubles" *ngFor="let percent of markerSeekBar" [ngStyle]="{'left': percent}" ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->
                  </div>
                  <div
                    class="column is-6 scroll-bar pos-relative"
                    style="overflow-y: auto; max-height: calc(100vh - 278px)"
                  >
                    <div
                      class="scroll-bar pos-relative"
                      infinite-scroll
                      style="padding-top: 17px"
                    >
                      @if (interVideoQuiz.length > 0) {
                      <div>
                        <div>
                          <div class="columns">
                            <div
                              class="history-tl-container scroll-bar pos-relative"
                              infinite-scroll
                            >
                              @for (qu of interVideoQuiz; track qu) {
                              <ul class="tl">
                                <form [formGroup]="editQuizzForm" novalidate>
                                  <li
                                    class="tl-item"
                                    ng-repeat="item in retailer_history"
                                  >
                                    <div class="timestamp">
                                      @if (!isEditQuestion[qu.quiz_id]) {
                                      <span>{{ qu.time }}</span>
                                      } @if (isEditQuestion[qu.quiz_id]) {
                                      <input
                                        type="text"
                                        class="input is-small"
                                        name="quiz_time"
                                        formControlName="quiz_time"
                                        style="
                                          width: 45px;
                                          position: absolute;
                                          right: 60px;
                                          height: 20px;
                                        "
                                      />
                                      }
                                    </div>
                                    @for (q of qu.questions; track q) {
                                    <div
                                      class="item-title"
                                      title="{{ q.question }}"
                                    >
                                      @if (!isEditQuestion[qu.quiz_id]) {
                                      <p>Q{{ q.qIndex }},</p>
                                      }
                                    </div>
                                    } @if (isEditQuestion[qu.quiz_id]) {
                                    <div class="item-title">
                                      <ul>
                                        @for ( q of editQuestIndList; track q;
                                        let i = $index) {
                                        <li class="question-title">
                                          <span class="has-text-weight-semibold"
                                            >Q{{ q.qIndex }}</span
                                          >. {{ q.question }}
                                          <a
                                            class="is-small removeQuestion"
                                            title="remove question"
                                            (click)="removeSelectIndex(i, q)"
                                            style="padding: 0px 0px 5px 13px"
                                            ><i
                                              class="fa fa-times"
                                              aria-hidden="true"
                                            ></i
                                          ></a>
                                        </li>
                                        }
                                      </ul>
                                    </div>
                                    } @if (isEditQuestion[qu.quiz_id]) {
                                    <a
                                      class="button is-link is-outlined is-small"
                                      style="height: 20px"
                                      (click)="viewQuestionSection()"
                                      >Add more question</a
                                    >
                                    } @if (!isEditQuestion[qu.quiz_id]) {
                                    <a
                                      class="mgh-small editQuestion has-tooltip-right"
                                      [ngClass]="{
                                        editQuestDisable:
                                          isEditBtnDisabled == true
                                      }"
                                      data-tooltip="Edit Interactive Quiz"
                                      (click)="editedSelectQuiz(qu.quiz_id)"
                                      ><i
                                        class="fa fa-pencil-square-o"
                                        aria-hidden="true"
                                      ></i
                                    ></a>
                                    } @if (!isEditQuestion[qu.quiz_id]) {
                                    <a
                                      class="mgh-small editQuestion has-tooltip-right"
                                      data-tooltip="Delete Interactive Quiz"
                                      (click)="deleteSelectQuiz(qu.quiz_id)"
                                      ><i
                                        class="fa fa-trash-o"
                                        aria-hidden="true"
                                      ></i
                                    ></a>
                                    }
                                    <div class="columns">
                                      <div class="column is-one-third">
                                        @if ( qu.is_required === true &&
                                        !isEditQuestion[qu.quiz_id] ) {
                                        <span class="isQuestReqClass"
                                          ><i class="has-text-danger">*</i>
                                          Required</span
                                        >
                                        } @if (isEditQuestion[qu.quiz_id]) {
                                        <label class="checkbox">
                                          <input
                                            type="checkbox"
                                            name="is_required"
                                            [checked]="qu.is_required"
                                            formControlName="is_required"
                                          />
                                          Required
                                          <i
                                            class="fa fa-info-circle has-tooltip-right"
                                            style="
                                              font-size: 14px !important;
                                              line-height: 22px;
                                            "
                                            aria-hidden="true"
                                            data-tooltip="Is required for timeline?"
                                          ></i>
                                        </label>
                                        }
                                      </div>
                                      @if (isEditQuestion[qu.quiz_id]) {
                                      <div
                                        class="column is-half actionBtnDeskView"
                                      >
                                        <a
                                          class="button is-small mar-0-5 has-tooltip-left"
                                          style="height: 20px"
                                          (click)="
                                            clearEditQuizzData(qu.quiz_id)
                                          "
                                          data-tooltip="Cancel"
                                          ><i
                                            class="fa fa-ban"
                                            aria-hidden="true"
                                          ></i
                                        ></a>
                                        @if (!showBtnSpinner) {
                                        <a
                                          class="button is-link is-small has-tooltip-left"
                                          style="height: 20px"
                                          (click)="
                                            updateVideoQuizData(
                                              qu.quiz_id,
                                              editQuizzForm.value
                                            )
                                          "
                                          title="Update"
                                          ><i
                                            class="fa fa-floppy-o"
                                            aria-hidden="true"
                                          ></i
                                        ></a>
                                        } @if (showBtnSpinner) {
                                        <a
                                          class="button is-link is-loading is-small"
                                          style="width: 22px; height: 20px"
                                        ></a>
                                        }
                                      </div>
                                      }
                                    </div>
                                  </li>
                                </form>
                              </ul>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                      <div class="columns" style="box-sizing: border-box">
                        <div
                          class="history-tl-container scroll-bar pos-relative"
                          infinite-scroll
                        >
                          <ul class="tl">
                            <form [formGroup]="videoQuizzForm" novalidate>
                              <li class="tl-item">
                                <div class="timestamp">
                                  <input
                                    type="text"
                                    class="input is-small"
                                    name="quiz_time"
                                    id=""
                                    #currentTime
                                    formControlName="quiz_time"
                                    style="
                                      width: 45px;
                                      position: absolute;
                                      right: 60px;
                                      height: 20px;
                                      top: -15px;
                                    "
                                    (change)="getChangedTime($event)"
                                    (click)="stopVideoStream()"
                                  />
                                </div>
                                <div class="item-title">
                                  <div class="column is-12">
                                    @if (questList.length === 0) {
                                    <a
                                      class="button is-link is-outlined is-small"
                                      (click)="viewQuestionSection()"
                                      >Add Question</a
                                    >
                                    } @for (item of questionIndList; track item)
                                    {
                                    <span
                                      style="color: #9e9e9e; font-weight: 600"
                                      title="{{ item.question }}"
                                    >
                                      Q{{ item.qIndex }},
                                    </span>
                                    }<br />
                                    @if (questList.length > 0) {
                                    <a
                                      class="button is-link is-outlined is-small"
                                      (click)="viewQuestionSection()"
                                      >Add more Question</a
                                    >
                                    }<br />
                                    @if (questList.length > 0) {
                                    <div class="columns">
                                      <div class="column is-one-third">
                                        <label class="checkbox">
                                          <input
                                            type="checkbox"
                                            name="is_required"
                                            formControlName="is_required"
                                          />
                                          Required
                                          <i
                                            class="fa fa-info-circle has-tooltip-right"
                                            style="
                                              font-size: 14px !important;
                                              line-height: 22px;
                                            "
                                            aria-hidden="true"
                                            data-tooltip="Is required for timeline?"
                                          ></i>
                                        </label>
                                      </div>
                                      <div
                                        class="column is-half actionBtnDeskView"
                                      >
                                        <a
                                          class="button is-small mar-0-5 has-tooltip-left"
                                          (click)="closeInteractiveQuiz()"
                                          data-tooltip="Clear"
                                          ><i
                                            class="fa fa-ban"
                                            aria-hidden="true"
                                          ></i
                                        ></a>
                                        @if (!showBtnSpinner) {
                                        <a
                                          class="button is-link is-small has-tooltip-left disSaveQuizBtn"
                                          (click)="
                                            saveQuestionData(
                                              videoQuizzForm.value
                                            )
                                          "
                                          title="Save"
                                          ><i
                                            class="fa fa-floppy-o"
                                            aria-hidden="true"
                                          ></i
                                        ></a>
                                        } @if (showBtnSpinner) {
                                        <a
                                          class="button is-link is-loading is-small"
                                          style="min-width: 100px"
                                        ></a>
                                        }
                                      </div>
                                    </div>
                                    }
                                  </div>
                                </div>
                              </li>
                            </form>
                          </ul>
                          <form
                            [formGroup]="videoQuizzForm"
                            style="display: none"
                          >
                            <div
                              class="column is-2"
                              style="position: relative; left: -40px"
                            >
                              <input
                                type="text"
                                class="input is-small"
                                name="quiz_time"
                                id=""
                                #currentTime
                                formControlName="quiz_time"
                                style="
                                  width: 65px;
                                  position: absolute;
                                  right: 0px;
                                "
                                (change)="getChangedTime($event)"
                                (click)="stopVideoStream()"
                              />
                            </div>
                            <div class="vertical"></div>
                            <div
                              class="column is-10"
                              style="margin-left: -20px"
                            >
                              @if (questList.length === 0) {
                              <a
                                class="button is-link is-outlined is-small"
                                (click)="viewQuestionSection()"
                                >Add Question</a
                              >
                              } @for (item of questionIndList; track item) {
                              <span
                                style="color: #9e9e9e; font-weight: 600"
                                title="{{ item.question }}"
                              >
                                Q{{ item.qIndex }},
                              </span>
                              }<br />
                              @if (questList.length > 0) {
                              <a
                                class="button is-link is-outlined is-small"
                                (click)="viewQuestionSection()"
                                >Add more Question</a
                              >
                              }<br />
                              @if (questList.length > 0) {
                              <div class="columns">
                                <div class="column is-one-third">
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      name="is_required"
                                      formControlName="is_required"
                                    />
                                    Required
                                    <i
                                      class="fa fa-info-circle has-tooltip-right"
                                      style="
                                        font-size: 14px !important;
                                        line-height: 22px;
                                      "
                                      aria-hidden="true"
                                      data-tooltip="Is required for timeline?"
                                    ></i>
                                  </label>
                                </div>
                                <div class="column is-half actionBtnDeskView">
                                  <a
                                    class="button is-small mar-0-5 has-tooltip-left"
                                    (click)="closeInteractiveQuiz()"
                                    data-tooltip="Clear"
                                    ><i class="fa fa-ban" aria-hidden="true"></i
                                  ></a>
                                  @if (!showBtnSpinner) {
                                  <a
                                    class="button is-link is-small has-tooltip-left disSaveQuizBtn"
                                    (click)="
                                      saveQuestionData(videoQuizzForm.value)
                                    "
                                    title="Save"
                                    ><i
                                      class="fa fa-floppy-o"
                                      aria-hidden="true"
                                    ></i
                                  ></a>
                                  } @if (showBtnSpinner) {
                                  <a
                                    class="button is-link is-loading is-small"
                                    style="min-width: 100px"
                                  ></a>
                                  }
                                </div>
                              </div>
                              }
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="column is-12 has-text-right">
                  <button
                    class="button is-small mar-0-5"
                    (click)="closeModalVideoQuiz()"
                  >
                    Cancel
                  </button>
                  @if (!showBtnSpinner) {
                  <button
                    class="button is-link is-small"
                    data-tooltip="Click here to Publish"
                    (click)="updatedInteractiveQuiz()"
                    [disabled]="interVideoQuiz.length === 0"
                  >
                    {{
                      videoQuizFound === true
                        ? "Update published video"
                        : "Publish Interactive Video"
                    }}
                  </button>
                  } @if (showBtnSpinner) {
                  <a
                    class="button is-link is-loading is-small"
                    style="min-width: 100px"
                  ></a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      <!--empty class lesson-->
      @if (totalLessonCount === 0) {
      <div class="empty-state">
        <div class="common-empty topic-notify">
          <article class="media">
            <div class="media-content has-text-centered">
              <!-- <img [src]="'../../../../assets/images/notification_empty.svg'" /> -->
              <!-- <i class="fa fa-book" aria-hidden="true"></i> -->
              <p>No records found</p>
              <!-- <span class="has-text-grey-light">Start adding Policy and share it with your user.</span> -->
            </div>
          </article>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}

<div class="showAssignment viewModalInterQuestion">
  <div class="modal" [ngClass]="{ 'is-modal-active': toggleModalSection }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="modal-card-head">
        <h4 style="font-weight: 700">Select Question</h4>
        <!-- <h6 style="position: absolute; left: 17px; top: 28px; font-size: 13px">
                                      (Please checked question you would like to add it to this video)
                                    </h6> -->
      </div>
      <section class="modal-card-body">
        <div class="content">
          <div class="columns">
            <div class="column">
              <div class="field">
                <div
                  class="panel panel-overflow scroll-bar"
                  infinite-scroll
                  [infiniteScrollDistance]="modalScrollDistance"
                  [infiniteScrollThrottle]="modalScrollThrottle"
                  [scrollWindow]="false"
                  (scrolled)="onScrollDown()"
                >
                  @for (item of getVideoQuestion; track item; let ind = $index)
                  {
                  <label
                    class="panel-block pos-relative"
                    (click)="selectQuestionId(ind, item)"
                    [ngClass]="{
                      isSelectHightlight: item.is_selected,
                      selQtHighlight: selectQuizIds.includes(item.question_id)
                    }"
                  >
                    @if (!item.selected) {
                    <span
                      class="icon-check is-small icon-alignuncheck is-pulled-left"
                    >
                      <!-- <i class="fa fa-check"></i> -->
                    </span>
                    }
                    <span class="control-label"
                      ><span
                        class="has-text-weight-medium"
                        style="font-weight: 600 !important"
                        >Q{{ ind + 1 }}</span
                      >.{{ item.question }}</span
                    >
                    @if (item.is_selected) {
                    <span class="icon is-small icon-align is-pulled-left">
                      <i class="fa fa-check"></i>
                    </span>
                    }
                  </label>
                  }
                  <pagination-loader
                    [showFetchLoader]="showPaginateSpinner"
                  ></pagination-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="modal-card-foot">
        <div class="column has-text-right">
          <button
            class="button is-small mar-0-5"
            (click)="closeAddQuestSection()"
          >
            Cancel
          </button>
          <button
            class="button is-link is-small disabledBtn"
            (click)="addQuestionSection()"
          >
            Add Selected
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
